import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')
const DefaultContainerInstructor = () => import('@/containers/DefaultContainerInstructor')

// Views
const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/Charts')
const Widgets = () => import('@/views/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const Flags = () => import('@/views/icons/Flags')
const FontAwesome = () => import('@/views/icons/FontAwesome')
const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons')
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/mfu/views/Login')
const Logout = () => import('@/mfu/views/Logout')

const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

const WithdrowCreate = () => import('@/mfu/views/news/index')
const WithdrowResult = () => import('@/mfu/views/news/result')
const WithdrowDetail = () => import('@/mfu/views/news/detail')
const WithdrowReport = () => import('@/mfu/views/news/report')
const WithdrowHistory = () => import('@/mfu/views/news/history')

const InstructorHistory = () => import('@/mfu/views/instructor/history')
const InstructorApproved = () => import('@/mfu/views/instructor/approved')
const InstructorDisApproved = () => import('@/mfu/views/instructor/disapproved')
const InstructorWaitApproved = () => import('@/mfu/views/instructor/waitapproved')
const Instructorwithdraw = () => import('@/mfu/views/instructor/withdraw')

const AdvisorApproved = () => import('@/mfu/views/advisor/approved')
const AdvisorDisApproved = () => import('@/mfu/views/advisor/disapproved')
const AdvisorWaitApproved = () => import('@/mfu/views/advisor/waitapproved')
const Advisorwithdraw = () => import('@/mfu/views/advisor/withdraw')

const DeanApproved = () => import('@/mfu/views/dean/approved')
const DeanDisApproved = () => import('@/mfu/views/dean/disapproved')
const DeanWaitApproved = () => import('@/mfu/views/dean/waitapproved')
const DeanWithdraw = () => import('@/mfu/views/dean/withdraw')


const StaffCalendar = () => import('@/mfu/views/staff/calender')
const Permisstion = () => import('@/mfu/views/staff/permisstion')
const SettingLogin = () => import('@/mfu/views/staff/login')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),

  routes: [
    {
      path: '/',
      redirect: '/login',
      name: 'login',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'logout',
          name: 'Logout',
          component: Logout
        }
      ]
    },
    {
      path: '/withdrow',
      redirect: '/withdrow/create',
      component: DefaultContainer,
      children: [

        {
          path: '/withdrow/create',
          name: "WithdrowCreate",
          component: WithdrowCreate
        },
        {
          path: '/withdrow/result',
          name: 'WithdrowResult',
          component: WithdrowResult,

        },
        {
          path: '/withdrow/result/detail',
          name: 'ResultDetail',
          props: true,
          component: WithdrowDetail,

        },
        {
          path: '/withdrow/result/report',
          name: 'ResultReport',
          props: true,
          component: WithdrowReport,

        },


        {
          path: '/withdrow/history',
          name: 'WithdrowHistory',
          component: WithdrowHistory
        }
      ]
    },

    {
      path: '/instructors',
      redirect: '/instructors/withdraw',
      component: DefaultContainer,
      children: [
        {
          path: '/instructor/approved',
          name: 'Instructor Approved',
          component: InstructorApproved
        },
        {
          path: '/instructor/disapproved',
          name: 'Instructor DisApproved',
          component: InstructorDisApproved
        },
        {
          path: '/instructor/waitapproved',
          name: 'Instructor WaitApproved',
          component: InstructorWaitApproved
        },
        {
          path: '/instructors/withdraw',
          name: 'Instructor Withdraw',
          component: Instructorwithdraw
        },
        {
          path: '/instructors/history',
          name: 'Instructor History',
          component: InstructorHistory
        }
      ]
    },
    {
      path: '/advisor',
      redirect: '/advisor/approved',
      component: DefaultContainer,
      children: [
        {
          path: '/advisor/approved',
          name: 'Withdrow Create',
          component: AdvisorApproved
        },
        {
          path: '/advisor/disapproved',
          name: 'Withdrow Create',
          component: AdvisorDisApproved
        },
        {
          path: '/advisor/waitapproved',
          name: 'Withdrow Create',
          component: AdvisorWaitApproved
        },
        {
          path: '/advisor/withdraw',
          name: 'Advisor Withdraw',
          component: Advisorwithdraw
        }
      ]
    },
    {
      path: '/dean',
      redirect: '/dean/approved',
      component: DefaultContainer,
      children: [
        {
          path: '/dean/approved',
          name: 'Withdrow Create',
          component: DeanApproved
        },
        {
          path: '/dean/disapproved',
          name: 'Withdrow Create',
          component: DeanDisApproved
        },
        {
          path: '/dean/waitapproved',
          name: 'Withdrow Create',
          component: DeanWaitApproved
        },
        {
          path: '/dean/withdraw',
          name: 'Dean Withdraw',
          component: DeanWithdraw
        }
      ]
    },
    {
      path: '/staff',
      redirect: '/staff/calendar',
      component: DefaultContainer,
      children: [
        {
          path: '/staff/calendar',
          name: 'Staff Calendar',
          component: StaffCalendar
        },
        {
          path: '/staff/permisstion',
          name: 'Withdrow Create',
          component: Permisstion
        },
        {
          path: '/staff/login',
          name: 'Withdrow Create',
          component: SettingLogin
        },
        {
          path: '/staff/withdraw',
          name: 'Dean Withdraw',
          component: Flags
        }
      ]
    },


    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
})
